var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMyOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 8.20002C3.3335 6.37985 3.3335 5.46976 3.68772 4.77455C3.99931 4.16302 4.4965 3.66584 5.10803 3.35425C5.80324 3.00002 6.71333 3.00002 8.5335 3.00002H15.4668C17.287 3.00002 18.1971 3.00002 18.8923 3.35425C19.5038 3.66584 20.001 4.16302 20.3126 4.77455C20.6668 5.46976 20.6668 6.37985 20.6668 8.20002V20.9987L17.6877 19.0667L14.9793 20.9987L12.0002 19.0667L9.021 20.9987L6.31266 19.0667L3.3335 20.9987V8.20002Z",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 8.20002C3.3335 6.37985 3.3335 5.46976 3.68772 4.77455C3.99931 4.16302 4.4965 3.66584 5.10803 3.35425C5.80324 3.00002 6.71333 3.00002 8.5335 3.00002H15.4668C17.287 3.00002 18.1971 3.00002 18.8923 3.35425C19.5038 3.66584 20.001 4.16302 20.3126 4.77455C20.6668 5.46976 20.6668 6.37985 20.6668 8.20002V20.9987L17.6877 19.0667L14.9793 20.9987L12.0002 19.0667L9.021 20.9987L6.31266 19.0667L3.3335 20.9987V8.20002Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3335 7.99996H16.6668",
    stroke: "#F7DE2A",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3335 11.3333H16.6668",
    stroke: "#F7DE2A",
    strokeWidth: 1.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3335 14.6666H12.0002",
    stroke: "#F7DE2A",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMyOrder);
export default __webpack_public_path__ + "static/media/icon_my_order.49c17efcfb2e167bf0877319d80b05a7.svg";
export { ForwardRef as ReactComponent };